// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const CheckDouble = createIcon(
  <path
    clipRule="evenodd"
    d="M16.436 8.40456L11.9163 12.9243L10.6435 11.6515L15.1633 7.13177C15.5147 6.7803 16.0846 6.7803 16.436 7.13177C16.7875 7.48324 16.7875 8.05309 16.436 8.40456ZM7.95649 14.3385L9.22928 15.6113L7.9727 16.8679C7.62123 17.2194 7.05138 17.2194 6.69991 16.8679L2.36322 12.5313C2.01174 12.1798 2.01174 11.6099 2.36321 11.2585C2.71468 10.907 3.28453 10.907 3.636 11.2585L7.3363 14.9587L7.95649 14.3385ZM21.6361 8.40495C21.9876 8.05348 21.9876 7.48363 21.6361 7.13216C21.2847 6.78069 20.7148 6.78069 20.3633 7.13216L12.5364 14.9591L8.8361 11.2589C8.48463 10.9074 7.91478 10.9074 7.56331 11.2589C7.21184 11.6103 7.21184 12.1802 7.56331 12.5317L11.9 16.8683C12.2515 17.2198 12.8213 17.2198 13.1728 16.8683L21.6361 8.40495Z"
    fillRule="evenodd"
  />,
);
